<div class="h-[100vh] overflow-hidden flex flex-col w-full items-center bg-surface-0 p-[10rem]">
    <div class="flex flex-row w-[70rem]">

        <div class="flex flex-1 flex-col gap-4 p-14 bg-surface-800 text-white items-center rounded-md">
            <h1 class="mt-20 text-5xl font-semibold">Bienvenue !</h1>
            <div class="grow"></div>
            <a href="https://logick.co">
                <img class="w-[8rem]" alt="Logick Logo" src="/img/logick-logo-white.svg" />
            </a>
            <div class="text-2xl font-light">La solution de billetterie au quotidien</div>
        </div>

        @if (step() === 'token') {
            <form class="flex flex-1 flex-col gap-6 p-14" [formGroup]="tokenForm" (ngSubmit)="submitToken()">
                <h1 class="text-3xl">Vérification</h1>
                <p class="text-surface-500 text-sm">Saisissez le code de vérification envoyé à votre adresse email.</p>
                <div class="w-full flex flex-col gap-2">
                    <div class="flex flex-col grow">
                        <label for="token">Code de vérification</label>
                        <input pInputText id="token" [fluid]="true" formControlName="token" autocomplete="one-time-code" />
                    </div>
                </div>
                @if (apiError()) {
                    <div class="text-red-500 text-sm">{{ apiError() }}</div>
                }
                <p-button type="submit" label="Vérifier le code" [fluid]="true" [disabled]="!tokenForm.valid" />
                <a routerLink="/forgot-password" class="underline text-sm">Renvoyer un code</a>
            </form>
        }

        @if (step() === 'new-password') {
            <form class="flex flex-1 flex-col gap-6 p-14" [formGroup]="passwordForm" (ngSubmit)="submitPassword()">
                <h1 class="text-3xl">Nouveau mot de passe</h1>
                <p class="text-surface-500 text-sm">Choisissez un nouveau mot de passe.</p>
                <div class="w-full flex flex-col gap-2">
                    <div class="flex flex-col grow gap-2">
                        <label for="password">Nouveau mot de passe</label>
                        <p-password id="password" [feedback]="false" [toggleMask]="true" [fluid]="true" formControlName="password" />
                        <ul class="flex flex-col gap-1 mt-1">
                            @for (rule of passwordRules(); track rule.label) {
                                <li class="flex items-center gap-2 text-sm" [class.text-green-600]="rule.valid" [class.text-surface-400]="!rule.valid">
                                    <i class="pi text-xs" [class.pi-check-circle]="rule.valid" [class.pi-circle]="!rule.valid"></i>
                                    {{ rule.label }}
                                </li>
                            }
                        </ul>
                    </div>
                    <div class="flex flex-col grow gap-1">
                        <label for="passwordConfirm">Confirmer le mot de passe</label>
                        <p-password id="passwordConfirm" [feedback]="false" [toggleMask]="true" [fluid]="true" formControlName="passwordConfirm" />
                        @if (passwordForm.hasError('mismatch') && passwordForm.get('passwordConfirm')?.dirty) {
                            <span class="text-red-500 text-sm">Les mots de passe ne correspondent pas.</span>
                        }
                    </div>
                </div>
                <p-button type="submit" label="Enregistrer le mot de passe" [fluid]="true" [disabled]="!passwordForm.valid || loading()" [loading]="loading()" />
            </form>
        }

    </div>
</div>
